import styled from 'styled-components';
import { theme } from '../styles/home.styles';

export const PageContainer = styled.div`
  background-color: #f0f2f5;
  padding: 30px;
  min-height: 100vh;
  font-family: 'Inter', sans-serif;
  /* Removed max-width and margin to align to the left */

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

export const BackButton = styled.button`
  background: transparent;
  border: none;
  color: #555;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 20px;
  transition: color 0.2s ease;

  &:hover {
    color: #007bff;
  }
`;

export const ProfileCard = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const StallTitle = styled.h2`
  margin: 0;
  font-size: 1.3rem;
  color: #333;
  font-weight: 700;
`;

export const StallSubTitle = styled.h3`
  margin: 4px 0 0 0;
  font-size: 0.8rem;
  color: #888;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 5px;

  svg {
    color: #ffd700;
  }
`;

export const ProfileInfoItem = styled.div`
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px dashed #e0e6ed;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const ProfileLabel = styled.p`
  font-size: 0.9rem;
  font-weight: 600;
  color: #555;
  margin: 0 0 4px 0;
  text-align: left;
`;

export const ProfileValue = styled.p`
  font-size: 0.8rem;
  color: #777;
  line-height: 1.4;
  text-align: left;
`;

export const SectionTitle = styled.h2`
  font-size: 1.2rem;
  color: #333;
  font-weight: 600;
  margin: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e6ed;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const InfoGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const InfoCard = styled.div`
  background-color: #fff;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const InfoLabel = styled.p`
  font-size: 0.85rem;
  font-weight: 500;
  color: #888;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    color: #007bff;
    font-size: 1rem;
  }
`;

export const InfoValue = styled.p`
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

export const ListingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ListingTitle = styled.h3`
  font-size: 1.1rem;
  color: #333;
  margin: 0;
`;

export const PriceTag = styled.span`
  background-color: #28a745;
  color: white;
  padding: 5px 10px;
  border-radius: 16px;
  font-weight: 600;
  font-size: 0.8rem;
  display: inline-block;
  align-self: flex-start;
  margin-top: 5px;
`;


export const ListingNavigation = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  
  span {
    font-size: 0.9rem;
    font-weight: 500;
    color: #666;
  }
`;

export const ListingNavButton = styled.button`
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:hover {
    background-color: #0056b3;
  }

  &.prev-media,
  &.next-media {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    background-color: white;
    color: #333;
    padding: 12px;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    transition: all 0.2s ease;

    &:hover {
      background-color: #f0f0f0;
      transform: translateY(-50%) scale(1.1);
    }
  }

  &.prev-media {
    left: 10px;
  }

  &.next-media {
    right: 10px;
  }
`;

export const LoadingMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  font-size: 1.1rem;
  color: #4a5568;
  flex-direction: column;
  gap: 12px;
  background-color: #f0f2f5;

  &:after {
    content: "";
    width: 40px;
    height: 40px;
    border: 4px solid #e9ecef;
    border-top: 4px solid #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {transform: rotate(0deg); }
    100% {transform: rotate(360deg); }
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  font-size: 1.1rem;
  color: #e74c3c;
  flex-direction: column;
  gap: 12px;
  text-align: center;
  padding: 20px;
  background-color: #f0f2f5;

  svg {
    font-size: 1.8rem;
    margin-bottom: 8px;
  }
`;

export const ListingContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  
  @media (min-width: 769px) {
    width: 35%; /* Adjust as needed for the balance between text and media */
  }
`;

export const ListingDescription = styled.p`
  color: #555;
  line-height: 1.6;
  margin: 10px 0;
`;

export const FeaturedBadge = styled.span`
  background-color: #ffd700;
  color: #333;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: bold;
  margin-left: 8px;
`;

export const ListingStats = styled.div`
  display: flex;
  gap: 15px;
  margin: 10px 0;
  flex-wrap: wrap;
`;

export const StatItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.8rem;
  color: #666;

  svg {
    color: #007bff;
    font-size: 0.9rem;
  }
`;

export const ZoomOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 30px;
  color: #fff;
  font-size: 3rem;
  font-weight: bold;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1001;
`;

export const ZoomedImageContainer = styled.div`
  max-width: 90%;
  max-height: 90%;
  position: relative;
`;

export const ZoomedImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  display: block;
  object-fit: contain;
`;

export const ZoomedVideo = styled.video`
  max-width: 100%;
  max-height: 100%;
  display: block;
`;

export const MediaGallery = styled.div<{emphasis?: boolean }>`
  position: relative; /* This is crucial for positioning the arrows */
  width: 100%;
  height: 600px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  
  .media-item {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
  }
  
  img, video {
    width: 100%;
    height: 100%;
    object-fit: contain; /* Use contain to prevent cropping and show the whole image */
  }
`;

export const ListingMediaContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (min-width: 769px) {
    width: 65%;
  }
`;

export const ListingDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ContactSocialSection = styled.div`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #e0e0e0;
  
  ${SectionTitle} {
    margin-bottom: 1rem;
  }
  
  ${InfoGrid} {
    margin-bottom: 1.5rem;
  }
`;
export const CompactInfoCard = styled.a`
  background-color: ${theme.colors.white};
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 5px;
  text-decoration: none; 
  color: #007bff;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    color: #007bff;
  }
`;

export const ProfileImage = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid ${theme.colors.primary};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;
export const ListingDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  @media (min-width: 992px) {
    flex-direction: row;
  }
`;
export const StallHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  padding: 15px;
  background-color: ${theme.colors.white};
  border-bottom: 1px solid ${theme.colors.borderLight};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }

  &.sidebar-header {
    @media (max-width: 992px) {
      display: none;
    }
    @media (min-width: 993px) {
      display: none;
    }
  }
`;
export const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media (max-width: 992px) {
    order: 2;
  }
`;

export const ContentArea = styled.main`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  @media (max-width: 992px) {
    order: 1;
  }
`;


export const ListingCard = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column; /* 👈 Set to column by default */
  gap: 15px;

  @media (min-width: 769px) {
    flex-direction: row; /* 👈 Override to row for larger screens */
    align-items: flex-start;
    gap: 30px;
  }
`;
export const MainContentGrid = styled.div`
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 25px;
  width: 100%;

  @media (max-width: 992px) {
    display: flex; /* 👈 Switch to flexbox on small screens */
    flex-direction: column; /* 👈 Stack items vertically */
    gap: 20px;
  }
`;